import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

interface Sale {
  created_at: string;
}

interface GraphProps {
  sales: Sale[];
  isLoading: boolean;
  date: Date;
}

interface SalesData {
  day: string;
  vendas: number;
}

function daysInMonth(month: number, year: number): number {
  return new Date(year, month, 0).getDate();
}

export const Graph: React.FC<GraphProps> = ({ sales, isLoading, date }) => {
  const [salesArray, setSalesArray] = useState<SalesData[]>([]);

  useEffect(() => {
    let salesPerDay: { [key: string]: number } = {};
    let currDay = 1;

    new Array(daysInMonth(date.getMonth(), date.getFullYear()))
      .fill(0)
      .forEach(() => {
        salesPerDay[currDay + "/" + (date.getMonth() + 1)] = 0;
        currDay++;
      });

    sales.forEach((s: Sale) => {
      const dt = new Date(s.created_at);
      const key = dt.getDate() + "/" + (dt.getMonth() + 1);

      salesPerDay[key] = (salesPerDay[key] || 0) + 1;
    });
    setSalesArray(
      Object.keys(salesPerDay).map((spd) => ({ 
        day: spd, 
        vendas: salesPerDay[spd] 
      }))
    );
  }, [sales])

  return (
    <div style={{ height: 200, width: "100%", marginTop: 20 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={salesArray}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="vendas" fill="#D91A5D" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
